var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"please-search"},[_vm._m(0),_c('div',[_c('h3',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-box-full"})])
}]

export { render, staticRenderFns }